import { systemIds } from '@/shared/utils';
/**
 * 设备
 */
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['equip'], // 为了获取基础路由
    };
};
//bussinessCode 和 各菜单 审批路由 的 映射
export const equipToPathNameMap = {
    //采购管理-设备配置计划表
    equip1010: ({ businessKey }) => commonFunc(`/equipPlan/configPlan/detail?id=${businessKey}`),
    //采购管理-设备配置计划变更表
    equip1020: ({ businessKey }) => commonFunc(`/equipPlan/configPlanAlter/detail?id=${businessKey}`),
    //采购管理-取消单
    equip1060: ({ businessKey, variables: { orderType, busType } }) => {
        let baseUrl = '';
        //区分菜单 采购合同3 和 采购订单4
        if (orderType === 3) {
            baseUrl = '/purchase/contract/';
        }
        else if (orderType === 4) {
            baseUrl = '/purchase/order/';
        }
        let url = '';
        //区分业务 作废 关闭 取消关闭 取消作废
        //busType: 1 | 2 | 3 | 4 //业务类型（1 作废 2 关闭 3 取消关闭 4取消作废）
        if (busType === 1) {
            url = 'cancel'; // /purchase/contract/cancel/detail
        }
        else if (busType === 2) {
            url = 'close';
        }
        else if (busType === 3) {
            url = 'removeClose';
        }
        else if (busType === 4) {
            url = 'removeCancel';
        }
        return commonFunc(`${baseUrl}${url}/detail?id=${businessKey}`);
    },
    //采购管理-设备采购申请表
    equip1050: ({ businessKey }) => commonFunc(`/purchase/apply/detail?id=${businessKey}`),
    //采购管理-设备合同表
    equip1030: ({ businessKey }) => commonFunc(`/purchase/contract/detail?id=${businessKey}`),
    //采购管理-设备合同表变更
    equip1070: ({ businessKey }) => commonFunc(`/purchase/contractAlter/detail?id=${businessKey}`),
};
